import React from "react";
import { Dialog } from "primereact/dialog";
import CustomButton, { Buttonlayout, CustomButtonOutlined } from "shared/CustomButton";
const DeleteModal = ({
    isOpen,
    setIsOpen,
    heading,
    cancelLabel,
    submitLabel,
    loading,
    onSubmit,
    onCancel,
    item
}) => {
    const footerContent = (
        <Buttonlayout >
            <CustomButtonOutlined
                disabled={loading}
                type="button"
                label={cancelLabel || "Cancel"}
                onClick={() => {
                    setIsOpen(!isOpen);
                    onCancel && onCancel();
                }}
            />
            {onSubmit && (
                <CustomButton
                    type="button"
                    loading={loading}
                    label={submitLabel || "Confirm"}
                    onClick={onSubmit}
                />
            )}
        </Buttonlayout>
    );

    const modalContent = () => {
        return (
            <span>
                {`Are you sure you want to delete the selected ${item || "item"} from the list?
            This action cannot be undone.`}
            </span>
        );
    };

    return (
        <Dialog
            visible={isOpen}
            className="invitation-modal"
            header={heading || "Delete"}
            footer={footerContent}
            style={{ width: "30vw" }}
            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
            onHide={() => {
                !loading && setIsOpen(false);
                onCancel && onCancel();
            }}
        >
            {modalContent()}
        </Dialog>
    );
};

export default DeleteModal;
